/* global $ riot: true */

let root;
if (typeof global !== 'undefined') root = global;
else if (typeof window !== 'undefined') root = window;
else root = {};

(function (window) {
  'use strict';

  // required libraries
  window.util = require('./lib/util');

  window.api = require('./lib/api');

  // window.parser = require('../../lib/parser');
  // form validators
  require('./lib/parsley');

  // animate.css
  $.fn.extend({
    animateCss: function (animationName) {
      const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd'
        + ' oanimationend animationend';
      this.addClass('animated ' + animationName).one(animationEnd, function () {
        window.$(this).removeClass('animated ' + animationName);
      });
      return this;
    }
  });

  // riot components
  riot.tag('raw', '<div></div>', function(opts) {
    this.set = () => { this.root.childNodes[0].innerHTML = opts.html; };
    this.on('update', this.set);
    this.on('mount', this.set);
  });

  // main application
  window.App = require('./lib/app');
}(root));
